import { useContext, useEffect, useState } from "react";
import CancelButton from "../../assets/images/CancelButton.svg";
import OpenSectionButton from "../../assets/images/OpenSectionButton.svg";
import UpdatesUnreadLogo from "../../assets/images/UpdatesUnreadLogo.svg";
import UpdatesReadLogo from "../../assets/images/UpdatesReadLogo.svg";
import UnreadUpdateDarkArror from "../../assets/images/UnreadUpdateDarkArror.svg";
import {
  HelpHubUpdatesTypes,
  QuestCriteriaWithStatusType,
} from "./CustomHelpHub.type";
import QuestContext from "../QuestWrapper";
import config from "../../config";
import { claimQuest } from "./CustomHelphub.service";
import HelphubSvg from "./CustomHelphubSvg";
import { getColorVariations } from "./components/helperfunction";
import { extractGradientColors, useGeneral } from "../../general";

const CustomHelpHubUpdates = (props: HelpHubUpdatesTypes) => {
  const {
    updateData,
    questId,
    userId,
    token,
    contentConfig,
    styleConfig,
    claimStatusUpdates = [],
    setClaimStatusUpdates,
    onlineComponent,
    setShowBottomNavigation,
    entityImage,
    setHelpHub,
    uniqueUserId,
    uniqueEmailId,
    campaignVariationId,
    entityAuthenticationToken,
    isActive,
    BrandTheme,
    QuestThemeData,
    isOffline,
    onClose
  } = props;
  const [filterData, setFilterData] = useState<QuestCriteriaWithStatusType[]>(
    []
  );
  const [searchData, setSearchData] = useState<string | number>("");
  const { apiKey, entityId, apiType, themeConfig, user } = useContext(
    QuestContext.Context
  );
  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;
  const general = useGeneral('quest')

  useEffect(() => {
    let data = updateData.filter((value: QuestCriteriaWithStatusType) => {
      return value?.linkTitle
        ?.toLowerCase()
        .includes(searchData?.toString().toLowerCase());
    });
    setFilterData(data);
  }, [updateData, searchData]);

  useEffect(() => {
    if (props?.isOffline) return;
    general.trackEvent(
      "quest-helphub-updates-loaded",
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    );
  }, []);

  const cleanTiptapHTML = (html = "") => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll('[data-node-view-wrapper]').forEach((el) => {
      el.replaceWith(...el.childNodes);
    });

    doc.querySelectorAll('[data-drag-handle]').forEach((el) => el.remove());

    doc.querySelectorAll('[draggable]').forEach((el) =>
      el.removeAttribute('draggable')
    );

    return doc.body.innerHTML;
  };

  const getTimeDifference = (date: string) => {
    const now = new Date().getTime();
    const past = new Date(date).getTime();
    const diffMs = now - past;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) return `Today`;
    if (minutes < 60) return `Today`;
    if (hours < 24) return `Today`;
    if (days === 1) return "Yesterday";
    if (days < 7) return `${days} day${days !== 1 ? "s" : ""} ago`;
    if (weeks < 5) return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
    if (months < 12) return `${months} month${months !== 1 ? "s" : ""} ago`;
    return `${years} year${years !== 1 ? "s" : ""} ago`;
  };

  const readUpdate = async (criteriaId: string, links?: string) => {
    if (onlineComponent) {
      let claimResponse = await claimQuest(
        BACKEND_URL,
        entityId,
        questId,
        userId,
        token,
        apiKey,
        criteriaId,
        campaignVariationId,
        [],
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );
      if (claimResponse.success) {
        setClaimStatusUpdates &&
          setClaimStatusUpdates([...claimStatusUpdates, criteriaId]);
      }
    } else {
      setClaimStatusUpdates &&
        setClaimStatusUpdates([...claimStatusUpdates, criteriaId]);
    }
  };

  const [showOneUpdate, setshowOneUpdate] = useState(false);
  const [updateOneData, setUpdateOneData] =
    useState<QuestCriteriaWithStatusType>();
  const [updateOneoutAnimation, setUpdateOneOutAnimation] = useState<
    boolean | null
  >(null);
  const [updateOutAnimation, setUpdateOutAnimation] = useState<boolean | null>(
    null
  );

  const [updateOutTempAnimation, setUpdateOutTempAnimation] = useState<
    boolean | null
  >(null);

  const handleShowUpdate = (value: any) => {
    setUpdateOutAnimation(true);
    setUpdateOneData(value);
    setTimeout(() => {
      setshowOneUpdate((prev) => !prev);
      setUpdateOneOutAnimation(false);
    }, 100);
  };

  const wrapLinksInText = (text: string) => {
    // const urlRegex = /(\bhttps?:\/\/[^\s]+)/gi;
    const urlRegex = /(\bhttps?:\/\/[^\s)]+)/gi; // This stops at ')' in URLs

    const parts = text.split(urlRegex);

    const wrappedText = parts.map((part, index) => {
      if (urlRegex.test(part)) {
        const cleanUrl =
          part.endsWith(".") ||
            part.endsWith(")") ||
            part.endsWith("]") ||
            part.endsWith("}")
            ? part?.slice(0, -1)
            : part;
        return (
          <a key={index} href={cleanUrl} target="_blank">
            {cleanUrl}
          </a>
        );
      }
      return part;
    });

    return <>{wrappedText}</>;
  };

  let color = BrandTheme?.primaryColor || QuestThemeData?.accentColor;
  if (color?.includes("gradient")) {
    color = extractGradientColors(color);
  }

  return (
    <>
      {!showOneUpdate && (
        <div
          className={`helpHubUpdatesCont animatedDissolve ${updateOutAnimation
            ? "updateOutAnimation"
            : updateOutTempAnimation
              ? "updateInAnimation"
              : ""
            }`}
        >
          <div className="q-custom-helphub-updates-upper-cont">
            <div className="q-custom-helphub-updates-upper-cont-text">
              <div>
                <div
                  className="q-custom-helphub-updates-upper-cont-text-head"
                >
                  What’s New
                </div>
                <div
                  className="q-custom-helphub-updates-upper-cont-text-para"
                >
                  Discover the latest perks and updates.
                </div>
              </div>
              <div className="q-custom-helphub-updates-upper-cont-text-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" onClick={() => { setHelpHub(false); isActive && isActive(false); onClose && onClose(false) }}>
                  <path d="M4.50586 11.4965L8.00119 8.00119L11.4965 11.4965M11.4965 4.50586L8.00053 8.00119L4.50586 4.50586" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>

          <div className="q-custom-helphub-updates-lower-cont">
            <div className="q-custom-helphub-search-cont">
              <input type="text" placeholder="Search for updates..." value={searchData} onChange={(e) => setSearchData(e.target.value)} />
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_3321_77061)">
                  <circle cx="7.66732" cy="7.66732" r="6.33333" stroke="#9CA3AF" stroke-width="0.917045" />
                  <path d="M13.332 13.332L14.6654 14.6654" stroke="#9CA3AF" stroke-width="0.917045" stroke-linecap="round" />
                </g>
                <defs>
                  <clipPath id="clip0_3321_77061">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="q-helphub-updates-lower-cont-data">
              <div className="q-helphub-updates-task-cont">
                {filterData.map(
                  (value: QuestCriteriaWithStatusType, index: number) =>
                    claimStatusUpdates.includes(value?.criteriaId) ? (
                      <div
                        className={`q-custom-helphub-updates-single-update-read`}
                        key={index}
                        onClick={() => {
                          handleShowUpdate(value);
                        }}
                      >
                        <div
                          className="update-img"
                        >
                          <img src={value?.imageUrl || entityImage} alt="" />
                        </div>

                        <div className="read-task-details">
                          <div className="update-time">
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                              <g clip-path="url(#clip0_3321_77086)">
                                <circle cx="2.44413" cy="2.49882" r="2.03788" fill="#6B7280" />
                              </g>
                              <defs>
                                <clipPath id="clip0_3321_77086">
                                  <rect width="4.89091" height="4.89091" fill="white" transform="translate(0 0.0546875)" />
                                </clipPath>
                              </defs>
                            </svg>
                            <p>
                              {getTimeDifference(value?.createdAt)}
                            </p>
                          </div>
                          <div className="update-head">
                            <p>
                              {value?.linkTitle}
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.67461 2.95437C5.88428 2.77465 6.19993 2.79893 6.37964 3.0086L10.3796 7.67526C10.5401 7.86251 10.5401 8.13881 10.3796 8.32606L6.37964 12.9927C6.19993 13.2024 5.88428 13.2267 5.67461 13.047C5.46495 12.8672 5.44067 12.5516 5.62038 12.3419L9.34147 8.00066L5.62038 3.65939C5.44067 3.44973 5.46495 3.13408 5.67461 2.95437Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.6" stroke-linecap="round" />
                            </svg>
                          </div>
                          <div
                            className="update-desc"
                            dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(value?.description) }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`q-custom-helphub-updates-single-update-read`}
                        key={index}
                        onClick={() => {
                          handleShowUpdate(value);
                          readUpdate(
                            value?.criteriaId
                          );
                        }}
                      >
                        <div
                          className="update-img"
                        >
                          <img src={value?.imageUrl || entityImage} alt="" />
                        </div>

                        <div className="custom-read-task-details-unread">
                          <div className="update-time">
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                              <circle cx="2.44413" cy="2.49882" r="2.03788" fill="#00CA8D" />
                            </svg>
                            <p>
                              New Update
                            </p>
                          </div>
                          <div className="update-head">
                            <p>
                              {value?.linkTitle}
                            </p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.67461 2.95437C5.88428 2.77465 6.19993 2.79893 6.37964 3.0086L10.3796 7.67526C10.5401 7.86251 10.5401 8.13881 10.3796 8.32606L6.37964 12.9927C6.19993 13.2024 5.88428 13.2267 5.67461 13.047C5.46495 12.8672 5.44067 12.5516 5.62038 12.3419L9.34147 8.00066L5.62038 3.65939C5.44067 3.44973 5.46495 3.13408 5.67461 2.95437Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.6" stroke-linecap="round" />
                            </svg>
                          </div>
                          <div
                            className="update-desc"
                            dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(value?.description) }}
                          />
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showOneUpdate && (
        <div
          className={`custom-q-update-one-container ${!updateOneoutAnimation ? "updateOneIn" : "updateOneOut"
            }`}
        >
          <div
            className="q-custom-update-one-container-header"
          >
            <div
              className="image-div"
              onClick={() => {
                setUpdateOneOutAnimation((prev) => !prev);
                setUpdateOutTempAnimation(true);
                setTimeout(() => {
                  setShowBottomNavigation && setShowBottomNavigation(true);
                  setUpdateOutAnimation(false);
                  setshowOneUpdate((prev) => !prev);
                }, 250);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3254 2.95437C10.1157 2.77465 9.80007 2.79893 9.62036 3.0086L5.62036 7.67526C5.45987 7.86251 5.45987 8.13881 5.62036 8.32606L9.62036 12.9927C9.80007 13.2024 10.1157 13.2267 10.3254 13.047C10.535 12.8672 10.5593 12.5516 10.3796 12.3419L6.65853 8.00066L10.3796 3.65939C10.5593 3.44973 10.535 3.13408 10.3254 2.95437Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.6" stroke-linecap="round" />
              </svg>
            </div>

            <div
              className="q-custom-update-one-container-header-title"
            >
              New Updates Details
            </div>
          </div>

          <div
            className="q-custom-update-one-container-data"
          >
            <div
              className="update-one-img"
            >
              <img src={updateOneData?.imageUrl || entityImage} alt="" />
            </div>

            <div className="custom-update-one-text-cont">
              <div className="custom-update-text-head-time">
                {updateOneData?.completed ? (
                  <div className="update-one-time-read">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="8"
                      viewBox="0 0 8 8"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_7694_4397)">
                        <circle
                          cx="4.00033"
                          cy="4.00002"
                          r="3.33333"
                          fill={
                            "#636363"
                          }
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_7694_4397">
                          <rect width="8" height="8" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p>
                      {getTimeDifference(updateOneData?.createdAt)}
                    </p>
                  </div>
                ) : (
                  <div className="update-one-time">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="7" viewBox="0 0 6 7" fill="none">
                      <g clip-path="url(#clip0_3321_77184)">
                        <circle cx="2.99805" cy="3.49805" r="2.5" fill="#00CA8D" />
                      </g>
                      <defs>
                        <clipPath id="clip0_3321_77184">
                          <rect width="6" height="6" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p>
                      New Update
                    </p>
                  </div>
                )}
                <div
                  className="update-one-head"
                >
                  {updateOneData?.linkTitle}
                </div>
              </div>

              <div
                className="custom-update-one-update-desc"
                dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(updateOneData?.description) }}
              />
            </div>
            {updateOneData?.linkUrl && (
              <div
                className="custom-update-one-update-button"
                onClick={() => {
                  window.open(updateOneData?.linkUrl, "_blank");
                }}
              >
                Learn More
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CustomHelpHubUpdates;
